import axiosInstance from "../Component/common/AxiosInterceptor";
import ApiService from "../Service/ApiService";
import { getAllRecords, deleteRecord } from "./IndexDBCrud";
import axios from "axios";
import { dbPromise } from "./db";

function mapUrlToKey(url, method) {
  const u = url.toLowerCase();
  if (
    u.includes("/users/save") ||
    u.includes("/users/update") ||
    u.includes("/users/get-by-id") ||
    u.includes("/users/get-logged-in-profile-info")
  )
    return "User";
  if (u.includes("/users/all")) return "AllUsers";
  if (u.includes("/hotels/getall") || u.includes("/hotels/all"))
    return "Hotels";
  if (
    u.includes("/hotels/add") ||
    u.includes("/hotels/update") ||
    u.includes("/hotels/delete")
  )
    return "Hotel";
  if (u.includes("/rooms/all") || u.includes("/rooms/alladmin"))
    return "AllRooms";
  if (u.includes("/rooms/room-by-id"))
    return (u.match(/room-by-id\/(\d+)/) || [])[1]
      ? `Room-${(u.match(/room-by-id\/(\d+)/) || [])[1]}`
      : "Room";
  if (
    u.includes("/rooms/add") ||
    u.includes("/rooms/update") ||
    u.includes("/rooms/delete")
  )
    return "Room";
  if (
    u.includes("/bookings/book-room") ||
    u.includes("/bookings/admin/book-room")
  )
    return "Booking";
  if (u.includes("/bookings/all")) return "AllBookings";
  if (u.includes("/bookings/get-booking-by-confirmation-code"))
    return (u.match(/confirmation-code\/(.+)/) || [])[1]
      ? `Booking-${(u.match(/confirmation-code\/(.+)/) || [])[1]}`
      : "Booking";
  // fallback
  return `Sync-${method}-${url}`;
}

async function processOutbox() {
  try {
    const outbox = await getAllRecords("outbox");
    if (!outbox || outbox.length === 0) return;
    for (const entry of outbox) {
      try {
        const { id, config } = entry;
        // Send the queued request
        const response = await axiosInstance(config);
        // axiosInterceptor returns apiResponse.data already (per interceptor)
        const payload = response;
        const key = mapUrlToKey(
          config.url || config.baseURL || "",
          (config.method || "").toUpperCase()
        );
        // Try to save to indexedDB using ApiService helper so it follows same conventions
        try {
          await ApiService.saveToIndexedDB(key, payload);
        } catch (e) {
          console.warn("Failed to save sync response to indexedDB", e);
        }
        // Remove processed outbox entry
        await deleteRecord("outbox", id);
      } catch (e) {
        // leave the entry in outbox for future retries
        console.warn("Failed to process outbox entry", e);
      }
    }
  } catch (e) {
    console.warn("processOutbox failed", e);
  }
}

export function startSync() {
  // process immediately if online
  if (typeof window !== "undefined") {
    window.addEventListener("online", () => {
      processOutbox();
    });
    if (navigator.onLine) processOutbox();
  }
}

export default { processOutbox, startSync };

export async function syncOutbox() {
  const db = await dbPromise;
  const all = await db.getAll("outbox");

  for (const item of all) {
    try {
      await axios(item.config);
      await db.delete("outbox", item.id);
    } catch {
      break; // stop if server fails
    }
  }
}
